export const atMostOnce = 0;
export const atLeastOnce = 1;
export const exactlyOnce = 2;